module.exports = __webpack_public_path__ + "img/home_bg.bd7aa3e1.png";